// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"register-organization-confirmation_wrapper__3xDjR"};